import request from './common/request'
import qs from 'qs'

import { SIMBART_MERCHANT_ACTIVITY_CONFIG_GIFT_URL } from './urls'

// 列表
async function all () {
  return request(
    {
      url: SIMBART_MERCHANT_ACTIVITY_CONFIG_GIFT_URL,
      method: 'GET'
    }
  )
}

// 插入
async function insert (data) {
  return request(
    {
      url: SIMBART_MERCHANT_ACTIVITY_CONFIG_GIFT_URL,
      method: 'POST',
      data: qs.stringify(data)
    }
  )
}

// 更新
async function update (data) {
  return request(
    {
      url: `${SIMBART_MERCHANT_ACTIVITY_CONFIG_GIFT_URL}/${data.id}`,
      method: 'PUT',
      data: qs.stringify(data)
    }
  )
}

export default {
  all,
  insert,
  update
}



// WEBPACK FOOTER //
// ./src/api/merchant-simbart-activity-config-gift.js